import { render, staticRenderFns } from "./CollectiveBilling.vue?vue&type=template&id=7b18137d&scoped=true"
import script from "./CollectiveBilling.vue?vue&type=script&lang=js"
export * from "./CollectiveBilling.vue?vue&type=script&lang=js"
import style0 from "./CollectiveBilling.vue?vue&type=style&index=0&id=7b18137d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b18137d",
  null
  
)

export default component.exports